import { render, staticRenderFns } from "./TecnicianOnlyMessage.vue?vue&type=template&id=ac8c62ea"
import script from "./TecnicianOnlyMessage.vue?vue&type=script&lang=js"
export * from "./TecnicianOnlyMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports